<template>
	<div id="yetx">
		<div class="yetx_main">
			<div class="tips">
				<div style="font-size: 16px">温馨提示：</div>
				<div class="tip-text">
					1、 最小提现：￥{{ minWithdrawMoney }} &nbsp;&nbsp;&nbsp;&nbsp; 最大提现：￥{{
						configInfo.DwMax.SysValue
					}}
					&nbsp;&nbsp;&nbsp;&nbsp; 每日提现次数：{{
						configInfo.DwCount.SysValue == 0 ? "无限制" : configInfo.DwCount.SysValue
					}}次 &nbsp;&nbsp;&nbsp;&nbsp; 每日最高提现：￥{{ configInfo.DwDayMax.SysValue }}
				</div>
				<div class="tip-text">2、 每日提现时间：{{ configInfo.DwStart.SysValue }}-{{ configInfo.DwEnd.SysValue }}</div>
			</div>
			<div style="padding-top: 25px">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="提现方式">
						<el-select v-model="form.DwId" placeholder="请选择提现方式" @change="handleWithdrawalChannelChange">
							<el-option v-for="item in bankList" :key="item.DwId" :label="item.Name" :value="item.DwId" />
						</el-select>
					</el-form-item>
					<el-form-item v-if="isCryptoChannel" label="钱包地址:">
						<el-select v-model="form.UbcId" placeholder="请选择钱包地址">
							<el-option
								v-for="item in choosedBank.banks"
								:key="item.UbcId"
								:label="item.NameNum"
								:value="item.UbcId"
							/>
						</el-select>
					</el-form-item>
					<el-form-item v-else label="选择银行:">
						<el-select v-model="form.UbcId" placeholder="请选择银行">
							<el-option
								v-for="item in choosedBank.banks"
								:key="item.UbcId"
								:label="item.NameNum"
								:value="item.UbcId"
							/>
						</el-select>
					</el-form-item>
					<el-form-item v-if="choosedBank.IsWalletValidation" :label="'再次输入:'">
						<el-input type="text" v-model.trim="form.CryptoWallet" placeholder="请再次输入钱包地址" />
					</el-form-item>
					<el-form-item label="提现金额:">
						<el-input type="number" v-model.number="form.DmMoney" placeholder="请输入提现金额" />
						<span v-if="isCryptoChannel && choosedBank.DwId != 2">
							元。 汇率 {{ cryptoRate }} = {{ cryptoToRMB }} 个</span
						>
					</el-form-item>
					<el-form-item label="真实姓名:">
						<el-input type="text" v-model.trim="form.FullName" maxlength="8" placeholder="请输入真实姓名" />
					</el-form-item>
					<el-form-item label="提现密码:">
						<el-input type="password" v-model.trim="form.PayPassword" maxlength="20" placeholder="请输入提现密码" />
					</el-form-item>
					<el-form-item>
						<el-button class="submit" type="primary" @click="onSubmit">确认</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div v-show="isQuick" class="quick-hint">
				温馨提示: <br />
				使用极速提现会预扣 10% 保证金, <br />
				点选确认到帐后会将保证金返还到账户 <br />
				在没到账之前请不要点击确认到账, <br />
				若在没到账情况下 点击确认到账出现没到账情况一概不负责
			</div>
		</div>

		<!-- 未绑定银行卡弹窗 -->
		<el-dialog title="提示" :visible.sync="dialogVisible" :show-close="false">
			<div class="close_login" @click="closeDialog">
				<span></span>
			</div>
			<div class="warning_img">
				<i class="el-icon-warning"></i>
			</div>
			<div style="text-align: center">请先绑定银行卡</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="goBindCart">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import dayjs from "dayjs";
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			dialogVisible: false,
			form: {
				DwId: "",
				DmMoney: "",
				UbcId: "",
				PayPassword: "",
				FullName: "",
				CryptoWallet: "",
			},
			configInfo: window.systemData,
			bankList: [],
		};
	},
	computed: {
		cryptoToRMB() {
			let dmMoney = this.form.DmMoney === "" ? 0 : this.form.DmMoney;
			return (dmMoney / this.choosedBank.Rate).toFixed(2);
		},
		choosedBank() {
			return this.bankList.find(item => item.DwId === this.form.DwId) || {};
		},
		isCryptoChannel() {
			return this.choosedBank.IsCryptoWallet || false;
		},
		cryptoRate() {
			return this.choosedBank.Rate || 0;
		},
		isQuick() {
			return this.form.DwId === 1;
		},
		userInfo() {
			return this.$store.state.userInfo;
		},
		minWithdrawMoney() {
			const isOldMember = +dayjs().diff(dayjs(this.userInfo.CreateTime), "h") > +this.configInfo.NewAccDefine.SysValue;
			return isOldMember ? +this.configInfo.DwMin.SysValue /* 500 */ : +this.configInfo.NewAccDwMin.SysValue; /* 100 */
		},
	},
	methods: {
		closeDialog() {
			this.dialogVisible = false;
		},
		_initOpenLoading() {
			this.loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
		},
		_initCloseLoading() {
			this.loading.close();
		},
		onSubmit() {
			if (this.form.DwId === "") return this.$message.error("提现方式未选择");
			if (this.form.UbcId === "") return this.$message.error(this.isCryptoChannel ? "钱包地址未选择" : "银行未选择");
			if (this.form.DmMoney === "") return this.$message.error("提现金额未填写");
			if (this.form.PayPassword === "") return this.$message.error("提现密码未填写");

			const intMoney = parseInt(this.form.DmMoney);
			if (intMoney < parseInt(this.minWithdrawMoney) || intMoney > parseInt(this.configInfo.DwMax.SysValue)) {
				return this.$message.error(
					"单笔提现最低 " + this.minWithdrawMoney + " 元,最高 " + this.configInfo.DwMax.SysValue + " 元"
				);
			}
			this._initOpenLoading();

			const url = "api/Cash/DrawMoneyApplyInfo";
			const defaultForm = {
				DwId: "",
				DmMoney: "",
				PayPassword: "",
				UbcId: "",
			};

			postAjax(url, this.form)
				.then(data => {
					if (data.IsSucess) {
						window.eventBus.$emit("refreshHeader");
						this.$message({
							message: "提现成功",
							type: "success",
						});
						this.form = { ...defaultForm };
					} else {
						this.$message.error(data.Message);
					}
				})
				.catch(() => {
					this.$message.error("网络异常，请刷新后在试");
				})
				.finally(() => {
					this._initCloseLoading();
				});
		},
		//去绑卡跳转路由
		goBindCart() {
			this.$emit("routerChange", "yhkgl");
			this.dialogVisible = false;
		},
		handleWithdrawalChannelChange() {
			this.form.UbcId = "";
		},
		getBankList() {
			let promises = [
				postAjax("api/Cash/GetDrawChannel"), // 取得提现方式
				postAjax("api/Bank/GetUserDrawBankList"), // 取得银行卡
				getAjax("api/Bank/GetUserCryptoWalletList"), // 取得加密钱包
				postAjax("api/Cash/IsWithdraw"), // 是否進入提現頁
			];

			Promise.all(promises)
				.then(items => {
					if (items[3].Data == false) {
						this.dialogVisible = true; //没卡先绑卡
					}

					const standardBanks = items[1].Data.map(item => ({
						...item,
						NameNum: item.BankName + "---" + item.BankNumber,
					}));

					const cryptoBanks = items[2].Data.map(item => ({
						...item,
						NameNum: `${item.BankName} (${item.BankNumber})`,
					}));

					this.bankList = items[0].Data.sort((a, b) => a.Sort - b.Sort).map(channel => ({
						...channel,
						banks: [
							...standardBanks.filter(bank => bank.IsCryptoWallet === channel.IsCryptoWallet),
							...cryptoBanks.filter(
								crypto => crypto.IsCryptoWallet === channel.IsCryptoWallet && crypto.DwId === channel.DwId
							),
						],
					}));

					this.form.DmMoney = this.minWithdrawMoney;
				})
				.catch(() => {
					this.$message.error("网络异常，请刷新后再试");
				});
		},
	},
	created() {
		this.getBankList();
	},
};
</script>
<style scoped>
#yetx .yetx_main {
	padding: 20px 20px 0 0;
}

/*提示*/
#yetx .tips {
	padding: 18px 0 20px 8px;
}

#yetx .tip-text {
	font-size: 14px;

	margin-top: 8px;
}

#yetx /deep/ .el-input {
	width: 320px;
}

.quick-hint {
	padding: 20px;
	line-height: 2rem;
	color: red;
	font-size: 14px;
}

.warning_img > .el-icon-warning {
	font-size: 54px;
	color: #1e8edd;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/yetx.vue